const blockSpecification = (Swiper, Navigation, Pagination, Autoplay) => {
	const swiperSpecyfication = document.querySelectorAll('.s-specification__swiper');
	if (swiperSpecyfication) {
		swiperSpecyfication.forEach((slide) => {
			/* eslint-disable no-new */
			new Swiper(slide, {
				spaceBetween: 30,
				centeredSlides: true,
				modules: [Navigation, Pagination, Autoplay],
				loop: true,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				// pagination: {
				//   el: '.swiper-pagination',
				//   clickable: true,
				// },
			});
		});
	}
};

export default blockSpecification;
